import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { MainColumn } from 'apps/auth/components/common/Layout/MainColumn/MainColumn';
import { StubPage } from 'apps/auth/components/common/Layout/StubPage';
import EmptyCardsGA from 'apps/auth/components/ga/cards/EmptyCardsGA';
import EmptyCardsLibre from 'apps/auth/components/ga/cards/EmptyCardsLibre';
import ListCardsGA from 'apps/auth/components/ga/cards/ListCardsGA';
import BasePageWithLeftMenu from 'apps/auth/components/utils/BasePageWithLeftMenu';
import { GA_MAIN_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PRODUCT_NAME } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { CARDS } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { GA_CARD } from 'apps/auth/constants/Constants';

const CardsGAPureComponent = (props) => {
    useEffect(() => {
        if (__isBrowser__) {
            amplitude.getInstance().logEvent(GA_MAIN_SCREEN_SHOWN, {
                [PRODUCT_NAME]: CARDS,
            });
        }
    }, []);

    if (props.loading) {
        return false;
    }

    if (props.switchOffGlobalAccountTabs && !props.gaMigration) {
        return (
            <BaseLayout stateOptions={{ isGA: true }}>
                <MainColumn isGaMigration>
                    <StubPage isGaMigration />
                </MainColumn>
            </BaseLayout>
        );
    }

    const getEmptyCards = () => {
        if (props.isLibre) {
            return <EmptyCardsLibre />;
        }
        return <EmptyCardsGA />;
    };

    return props.cards?.length === 0 ? getEmptyCards() : <ListCardsGA />;
};
const mapStateToProps = (state) => {
    return {
        cards: state.extra.cards,
        isLibre: state.extra.isLibre,
        switchOffGlobalAccountTabs: state.extra.switchOffGlobalAccountTabs,
        gaMigration: state.extra.gaMigration,
    };
};

const CardsGAPage = connect(mapStateToProps)(BasePageWithLeftMenu(CardsGAPureComponent, GA_CARD));

export default CardsGAPage;
